(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = global || self, global.Pinecone = factory());
}(this, (function () { 'use strict';

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(source, true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(source).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  /**
   * Accordion class.
   */
  var Accordion =
  /*#__PURE__*/
  function () {
    /**
     * Constructor.
     *
     * @param {DomNode} container
     * @param {Object} options
     */
    function Accordion(container, options) {
      var _this = this;

      _classCallCheck(this, Accordion);

      this.container = container;
      this.config = _objectSpread2(_objectSpread2({}, {
        headingSelector: '.accordion__heading',
        paneSelector: '.accordion__pane',
        controlSelector: '.accordion__control'
      }), options);
      this.panes = this.container.querySelectorAll(this.config.paneSelector);
      Array.prototype.forEach.call(this.panes, function (pane) {
        _this.initPane(pane);
      });
      this.handleClick = this.handleClick.bind(this);
      this.addEventListeners();
    }
    /**
     * Initialize a pane within the accordion.
     *
     * @param {DomNode} pane
     */


    _createClass(Accordion, [{
      key: "initPane",
      value: function initPane(pane) {
        var heading = pane.querySelector(this.config.headingSelector);
        var ctrl = document.createElement('button');
        ctrl.setAttribute('class', 'accordion__control');
        ctrl.setAttribute('aria-expanded', 'false');
        ctrl.setAttribute('type', 'button');
        ctrl.innerHTML = "\n\t\t\t".concat(heading.textContent, "\n\t\t\t<svg class=\"icon icon--chevron-down\" viewBox=\"0 0 20 20\" aria-hidden=\"true\" focusable=\"false\" xmlns=\"http://www.w3.org/2000/svg\"><path id=\"chevron-down\" d=\"m10 15a1 1 0 0 1 -.71-.29l-5-5a1 1 0 0 1 1.42-1.42l4.29 4.3 4.29-4.3a1 1 0 0 1 1.42 1.42l-5 5a1 1 0 0 1 -.71.29z\" fill=\"currentColor\"/></svg>\n\t\t");
        heading.parentNode.insertBefore(ctrl, heading.nextElementSibling);
        heading.parentNode.removeChild(heading);
      }
      /**
       *
       * @param {Event} event
       */

    }, {
      key: "handleClick",
      value: function handleClick(event) {
        if (!event.target.closest(this.config.controlSelector)) return;
        var ctrl = event.target.closest(this.config.controlSelector);
        var expanded = 'true' === ctrl.getAttribute('aria-expanded') || false;
        Array.prototype.forEach.call(this.container.querySelectorAll('.accordion__control'), function (el) {
          el.setAttribute('aria-expanded', false);
          el.parentNode.classList.remove('accordion__pane--expanded');
        });
        ctrl.setAttribute('aria-expanded', !expanded);

        if (expanded) {
          ctrl.parentNode.classList.remove('accordion__pane--expanded');
        } else {
          ctrl.parentNode.classList.add('accordion__pane--expanded');
        }
      }
      /**
       * Add click event listeners.
       */

    }, {
      key: "addEventListeners",
      value: function addEventListeners() {
        this.container.addEventListener('click', this.handleClick, false);
      }
    }]);

    return Accordion;
  }();

  /**
   * Card class.
   */
  var Card =
  /*#__PURE__*/
  function () {
    /**
     * Constructor.
     *
     * @param {DomNode} card
     * @param {Object} options
     */
    function Card(card, options) {
      _classCallCheck(this, Card);

      this.card = card;
      this.config = _objectSpread2(_objectSpread2({}, {
        cardLinkSelector: '.card__link'
      }), options);
      this.initCard(card);
    }
    /**
     * Initialize card
     *
     * @param {DomNode} card
     */


    _createClass(Card, [{
      key: "initCard",
      value: function initCard(card) {
        var link = card.querySelector(this.config.cardLinkSelector);
        var down, up;
        card.style.cursor = 'pointer';

        card.onmousedown = function () {
          return down = +new Date();
        };

        card.onmouseup = function () {
          up = +new Date();

          if (200 > up - down) {
            link.click();
          }
        };
      }
    }]);

    return Card;
  }();

  /**
   * Deselect All button class.
   */
  var DeselectAll =
  /*#__PURE__*/
  function () {
    /**
     * Constructor.
     *
     * @param {DomNode} btn
     * @param {Object} options
     */
    function DeselectAll(btn, options) {
      _classCallCheck(this, DeselectAll);

      this.btn = btn;
      this.config = _objectSpread2(_objectSpread2({}, {}), options);
      this.handleClick = this.handleClick.bind(this);
      this.addEventListeners();
    }
    /**
     * Handle click.
     *
     * @param {Event} event
     */


    _createClass(DeselectAll, [{
      key: "handleClick",
      value: function handleClick() {
        var inputGroup = this.btn.parentNode.querySelector('.input-group__parent');
        var checkboxes = inputGroup.querySelectorAll('[type="checkbox"]');
        var customCheckboxes = inputGroup.querySelectorAll('[role="checkbox"]');
        var hiddenInputs = inputGroup.querySelectorAll('[type="hidden"]');
        Array.prototype.forEach.call(checkboxes, function (checkbox) {
          checkbox.checked = false;
        });

        if (0 < customCheckboxes.length) {
          Array.prototype.forEach.call(customCheckboxes, function (customCheckbox) {
            customCheckbox.setAttribute('aria-checked', false);
          });
        }

        if (0 < hiddenInputs.length) {
          Array.prototype.forEach.call(hiddenInputs, function (hiddenInput) {
            hiddenInput.setAttribute('value', '');
          });
        }
      }
      /**
       * Add event listeners.
       */

    }, {
      key: "addEventListeners",
      value: function addEventListeners() {
        this.btn.addEventListener('click', this.handleClick, false);
      }
    }]);

    return DeselectAll;
  }();

  /**
   * Dialog Handler.
   */

  /**
   * Dialog class.
   */
  var Dialog =
  /*#__PURE__*/
  function () {
    /**
     * Constructor.
     *
     * @param {DomNode} btn
     * @param {Object} options
     */
    function Dialog(btn, options) {
      _classCallCheck(this, Dialog);

      this.btn = btn;
      this.config = _objectSpread2(_objectSpread2({}, {
        title: 'Confirm action',
        question: 'Do you want to do this?',
        dismiss: 'No',
        confirm: 'Yes',
        inputLabel: false,
        inputDescription: false,
        input: false,
        callback:
        /**
         * Callback for when one was not provided.
         */
        function callback(input) {
          if (input) {
            console.log("Responded with \"".concat(input, "\".")); // eslint-disable-line
          } else {
            console.error('Callback not provided.'); // eslint-disable-line
          }
        }
      }), options);
      this.invokeDialog = this.invokeDialog.bind(this);
      this.handleClick = this.handleClick.bind(this);
      this.addEventListeners();
    }
    /**
     *
     *
     */


    _createClass(Dialog, [{
      key: "handleClick",
      value: function handleClick() {
        this.invokeDialog(this.config.callback);
      }
      /**
       * Invoke dialog.
       *
       * @param {Function} callback
       */

    }, {
      key: "invokeDialog",
      value: function invokeDialog(callback) {
        var _this = this;

        var elems = document.querySelectorAll('body > *:not([aria-live])');
        Array.prototype.forEach.call(elems, function (elem) {
          elem.setAttribute('inert', 'inert');
        });
        var unique = +new Date();
        var dialog = document.createElement('div');
        dialog.setAttribute('role', 'dialog');
        dialog.setAttribute('aria-labelledby', "q-".concat(unique));
        dialog.setAttribute('aria-describedby', "q-".concat(unique + 1));
        var innerHtml = "<h2 id=\"q-".concat(unique, "\">").concat(this.config.title, "</h2>");

        if (this.config.question) {
          innerHtml += "<p id=\"q-".concat(unique + 1, "\">").concat(this.config.question, "</p>");
        }

        if (this.config.input && this.config.inputLabel) {
          dialog.classList.add('form');
          innerHtml += '<div class="input-group">';
          innerHtml += "<label for=\"".concat(this.config.input, "\">").concat(this.config.inputLabel, "</label>");

          if (this.config.inputDescription) {
            innerHtml += "<input id=\"".concat(this.config.input, "\" type=\"text\" name=\"").concat(this.config.input, "\" aria-describedby=\"").concat(this.config.input, "-description\" />");
            innerHtml += "<p id=\"".concat(this.config.input, "-description\" class=\"input-group__description\">").concat(this.config.inputDescription, "</p>");
          } else {
            innerHtml += "<input id=\"".concat(this.config.input, "\" type=\"text\" name=\"").concat(this.config.input, "\" />");
          }

          innerHtml += '</div>';
        }

        innerHtml += "\n\t\t\t<div class=\"buttons\">\n\t\t\t\t<button class=\"button button--secondary dismiss\">".concat(this.config.dismiss, "</button>\n\t\t\t\t<button class=\"button confirm\">").concat(this.config.confirm, "</button>\n\t\t\t</div>\n\t\t");
        dialog.innerHTML = innerHtml;
        var overlay = document.createElement('div');
        overlay.setAttribute('inert', 'inert');
        overlay.classList.add('overlay');
        /**
         * Handle close event.
         */

        var close = function close() {
          Array.prototype.forEach.call(elems, function (elem) {
            if (elem !== dialog) {
              elem.removeAttribute('inert');
            }
          });
          dialog.parentNode.removeChild(dialog);
          overlay.parentNode.removeChild(overlay);
          trigger.focus();
        };

        var confirm = dialog.querySelector('.confirm');
        var dismiss = dialog.querySelector('.dismiss');
        var trigger = this.btn;
        document.body.appendChild(overlay);
        document.body.appendChild(dialog);

        if (this.config.input) {
          document.getElementById(this.config.input).focus();
        } else {
          dismiss.focus();
        }

        confirm.onclick = function () {
          var input = document.getElementById(_this.config.input) ? document.getElementById(_this.config.input).value : false;
          close();
          callback(input);
        };

        dismiss.onclick = function () {
          return close();
        };

        dialog.addEventListener('keydown', function (e) {
          if (27 == e.keyCode) {
            e.preventDefault();
            close();
          }
        });
      }
      /**
       * Add event listeners.
       */

    }, {
      key: "addEventListeners",
      value: function addEventListeners() {
        this.btn.addEventListener('click', this.handleClick, false);
      }
    }]);

    return Dialog;
  }();

  /**
   * DisclosureButton class.
   */
  var DisclosureButton =
  /*#__PURE__*/
  function () {
    /**
     * Constructor.
     *
     * @param {DomNode} label
     * @param {Object} options
     */
    function DisclosureButton(label, options) {
      _classCallCheck(this, DisclosureButton);

      this.label = label;
      this.container = this.label.parentNode;
      this.config = _objectSpread2(_objectSpread2({}, {
        controlSelector: '.disclosure-button',
        buttonVariant: 'button--borderless',
        visuallyHiddenLabel: false
      }), options);
      this.initDisclosure();
      this.handleClick = this.handleClick.bind(this);
      this.addEventListeners();
    }
    /**
     * Initialize content within the disclosure.
     */


    _createClass(DisclosureButton, [{
      key: "initDisclosure",
      value: function initDisclosure() {
        var ctrl = document.createElement('button');
        var className = this.config.buttonVariant ? "button ".concat(this.config.buttonVariant, " disclosure-button") : 'button disclosure-button';
        var label = this.config.visuallyHiddenLabel ? "<span class=\"screen-reader-text\">".concat(this.label.textContent, "</span>") : this.label.textContent;
        ctrl.setAttribute('class', className);
        ctrl.setAttribute('aria-expanded', 'false');
        ctrl.setAttribute('type', 'button');
        ctrl.innerHTML = "\n\t\t\t".concat(label, "<svg class=\"icon icon--chevron-down\" viewBox=\"0 0 20 20\" aria-hidden=\"true\" focusable=\"false\" xmlns=\"http://www.w3.org/2000/svg\"><path id=\"chevron-down\" d=\"m10 15a1 1 0 0 1 -.71-.29l-5-5a1 1 0 0 1 1.42-1.42l4.29 4.3 4.29-4.3a1 1 0 0 1 1.42 1.42l-5 5a1 1 0 0 1 -.71.29z\" fill=\"currentColor\"/></svg>\n\t\t");
        this.container.insertBefore(ctrl, this.label.nextElementSibling);
        this.container.removeChild(this.label);
      }
      /**
       *
       * @param {Event} event
       */

    }, {
      key: "handleClick",
      value: function handleClick(event) {
        if (!event.target.closest(this.config.controlSelector)) return;
        var ctrl = event.target.closest(this.config.controlSelector);
        var expanded = 'true' === ctrl.getAttribute('aria-expanded') || false;
        ctrl.setAttribute('aria-expanded', !expanded);
      }
      /**
       * Add click event listeners.
       */

    }, {
      key: "addEventListeners",
      value: function addEventListeners() {
        this.container.addEventListener('click', this.handleClick, false);
      }
    }]);

    return DisclosureButton;
  }();

  /**
   * Filter List Handler.
   */
  var FilterList =
  /*#__PURE__*/
  function () {
    /**
     * Constructor.
     *
     * @param {DomNode} container
     * @param {Object} options
     */
    function FilterList(container, showCtrl, hideCtrl, options) {
      _classCallCheck(this, FilterList);

      this.container = container;
      this.showCtrl = showCtrl;
      this.hideCtrl = hideCtrl;
      this.config = _objectSpread2(_objectSpread2({}, {
        showCtrlSelector: '#show-filters',
        hideCtrlSelector: '#hide-filters'
      }), options);
      this.handleOverlay = this.handleOverlay.bind(this);
      this.handleResize = this.handleResize.bind(this);
      this.addEventListeners();
    }
    /**
     * Handle overlay.
     */


    _createClass(FilterList, [{
      key: "handleOverlay",
      value: function handleOverlay(event) {
        if (!event.target.closest(this.config.showCtrlSelector) && !event.target.closest(this.config.hideCtrlSelector)) return false;
        var elems = document.querySelectorAll('body > *:not([aria-live])');

        if (event.target.closest(this.config.showCtrlSelector)) {
          document.body.classList.add('has-modal');
          Array.prototype.forEach.call(elems, function (elem) {
            elem.inert = true;
          });
          this.container.parentNode.removeChild(this.container);
          document.body.insertBefore(this.container, document.body.firstChild);
          var heading = this.container.querySelector('h2');
          var accordion = this.container.querySelector('.accordion');
          var firstBtn = accordion.querySelector('button');
          heading.classList.remove('screen-reader-text');
          accordion.style.display = 'block';
          this.container.classList.add('filters--expanded');
          firstBtn.focus();
        } else {
          Array.prototype.forEach.call(elems, function (elem) {
            elem.inert = false;
          });
          this.container.classList.remove('filters--expanded');
          this.container.parentNode.removeChild(this.container);
          this.showCtrl.parentNode.insertBefore(this.container, this.showCtrl.nextSibling);
          document.body.classList.remove('has-modal');
          this.showCtrl.focus();
        }
      }
      /**
       * Handle window resize events.
       */

    }, {
      key: "handleResize",
      value: function handleResize() {
        var timeout;

        if (this.container.classList.contains('filters--expanded')) {
          if (!timeout) {
            timeout = setTimeout(this.removeOverlay(timeout), 66);
          }
        }
      }
      /**
       * Resize function.
       */

    }, {
      key: "removeOverlay",
      value: function removeOverlay(timeout) {
        timeout = null;
        var viewportWidth = window.innerWidth || document.documentElement.clientWidth;

        if (1279 < viewportWidth) {
          var elems = document.querySelectorAll('body > *');
          Array.prototype.forEach.call(elems, function (elem) {
            elem.removeAttribute('inert');
          });
          this.container.classList.remove('filters--expanded');
          this.container.parentNode.removeChild(this.container);
          this.showCtrl.parentNode.insertBefore(this.container, this.showCtrl.nextSibling);
          document.body.classList.remove('has-modal');
        }

        return timeout;
      }
      /**
       * Add event listeners.
       */

    }, {
      key: "addEventListeners",
      value: function addEventListeners() {
        document.addEventListener('click', this.handleOverlay, false);
        window.addEventListener('resize', this.handleResize, false);
      }
    }]);

    return FilterList;
  }();

  /**
   * Icon Handler.
   *
   * Props Chris Coyier (https://css-tricks.com/inline-svg-cached/)
   */
  var Icon =
  /*#__PURE__*/
  function () {
    /**
     * Constructor.
     *
     * @param {DomNode} icon
     * @param {Object} options
     */
    function Icon(icon, options) {
      _classCallCheck(this, Icon);

      this.icon = icon;
      this.config = _objectSpread2(_objectSpread2({}, {// TODO
      }), options);
      this.inlineSvg(icon);
    }
    /**
     *
     * @param {DomNode} icon
     */


    _createClass(Icon, [{
      key: "inlineSvg",
      value: function inlineSvg(icon) {
        if (!icon.querySelector('use')) return false;
        var classNames = icon.classList;
        var ariaHidden = icon.getAttribute('aria-hidden');
        var focusable = icon.getAttribute('focusable');
        var viewBox = icon.getAttribute('viewBox');
        var url = icon.querySelector('use').getAttribute('href');
        fetch(url).then(function (response) {
          return response.text();
        }).then(function (data) {
          var newEl = document.createElement('span');
          newEl.innerHTML = data;
          newEl.firstChild.setAttribute('class', classNames);
          if (ariaHidden) newEl.firstChild.setAttribute('aria-hidden', true);
          if (focusable) newEl.firstChild.setAttribute('focusable', true);
          if (viewBox) newEl.firstChild.setAttribute('viewBox', viewBox);
          icon.parentNode.replaceChild(newEl, icon);
          var parent = newEl.parentNode;

          while (newEl.firstChild) {
            parent.insertBefore(newEl.firstChild, newEl);
          }

          parent.removeChild(newEl);
        });
      }
    }]);

    return Icon;
  }();

  /**
   * Menu class.
   */
  var Menu =
  /*#__PURE__*/
  function () {
    /**
     * Constructor.
     *
     * @param {DomNode} menu
     * @param {DomNode} toggle
     * @param {Object} options
     */
    function Menu(menu, toggle, options) {
      var _this = this;

      _classCallCheck(this, Menu);

      this.menu = menu;
      this.toggle = toggle;
      this.config = _objectSpread2(_objectSpread2({}, {
        menuToggleSelector: '.menu-toggle',
        dropdownButtonSelector: '.menu__item',
        parentMenuSelector: '.menu__submenu-wrapper',
        childMenuSelector: '.menu__submenu'
      }), options);
      this.parents = document.querySelectorAll(this.config.parentMenuSelector);
      Array.prototype.forEach.call(this.parents, function (parent) {
        _this.initDropdown(parent);
      });
      this.handleToggle = this.handleToggle.bind(this);
      this.handleDropdown = this.handleDropdown.bind(this);
      this.handleBlur = this.handleBlur.bind(this);
      this.handleKeyDown = this.handleKeyDown.bind(this);
      this.addEventListeners();
    }
    /**
     * Initialize dropdown menus
     *
     * @param {DomNode} parent
     */


    _createClass(Menu, [{
      key: "initDropdown",
      value: function initDropdown(parent) {
        var link = parent.parentNode.querySelector("".concat(this.config.parentMenuSelector, " > a"));
        var btn = document.createElement('button');
        btn.className = 'menu__item';
        btn.setAttribute('aria-expanded', false);
        btn.innerHTML = "\n\t\t\t".concat(link.innerHTML, "\n\t\t\t<svg class=\"icon icon--chevron-down\" viewBox=\"0 0 20 20\" aria-hidden=\"true\" focusable=\"false\" xmlns=\"http://www.w3.org/2000/svg\"><path id=\"chevron-down\" d=\"m10 15a1 1 0 0 1 -.71-.29l-5-5a1 1 0 0 1 1.42-1.42l4.29 4.3 4.29-4.3a1 1 0 0 1 1.42 1.42l-5 5a1 1 0 0 1 -.71.29z\" fill=\"currentColor\"/></svg>\n\t\t");
        parent.insertBefore(btn, parent.firstChild);
        parent.removeChild(link);
      }
      /**
       *
       * @param {Event} event
       */

    }, {
      key: "handleToggle",
      value: function handleToggle(event) {
        if (!event.target.closest(this.config.menuToggleSelector)) return;
        var btn = event.target.closest(this.config.menuToggleSelector);
        var expanded = 'true' === btn.getAttribute('aria-expanded') || false;
        btn.setAttribute('aria-expanded', !expanded);

        if (!expanded) {
          var firstItem = this.menu.querySelector('a, button');
          firstItem.focus();
        }
      }
      /**
       *
       * @param {Event} event
       */

    }, {
      key: "handleDropdown",
      value: function handleDropdown(event) {
        if (!event.target.closest(this.config.dropdownButtonSelector)) {
          var openDropDown = this.menu.querySelector('[aria-expanded="true"]');

          if (openDropDown) {
            openDropDown.setAttribute('aria-expanded', false);
          }
        } else {
          var btn = event.target.closest(this.config.dropdownButtonSelector);
          var expanded = 'true' === btn.getAttribute('aria-expanded') || false;

          if (!expanded) {
            var dropdownButtons = this.menu.querySelectorAll('button');
            Array.prototype.forEach.call(dropdownButtons, function (dropdownButton) {
              dropdownButton.setAttribute('aria-expanded', false);
            });
          }

          btn.setAttribute('aria-expanded', !expanded);
        }
      }
      /**
       *
       * @param {Event} event
       */

    }, {
      key: "handleBlur",
      value: function handleBlur(event) {
        if (!event.relatedTarget) return;

        if ('true' === this.toggle.getAttribute('aria-expanded') && !event.relatedTarget.closest('.menu') && event.relatedTarget !== this.toggle) {
          this.toggle.setAttribute('aria-expanded', false);
        } else {
          var expanded = this.menu.querySelector('[aria-expanded="true"]');
          if (!expanded) return;
          var parent = expanded.closest(this.config.parentMenuSelector);

          if (event.relatedTarget.parentNode.parentNode.parentNode !== parent && event.relatedTarget.parentNode !== parent) {
            expanded.setAttribute('aria-expanded', false);
          }
        }
      }
      /**
       * @param {Event} event
       */

    }, {
      key: "handleKeyDown",
      value: function handleKeyDown(event) {
        var _this2 = this;

        var expanded = this.menu.parentNode.querySelectorAll('[aria-expanded="true"]');
        if (!expanded) return false;

        if (27 === event.keyCode) {
          Array.prototype.forEach.call(expanded, function (el) {
            el.setAttribute('aria-expanded', false);

            if (el == _this2.toggle) {
              el.focus();
            }
          });
        }
      }
      /**
       * Add click event listeners.
       */

    }, {
      key: "addEventListeners",
      value: function addEventListeners() {
        var _this3 = this;

        document.addEventListener('click', this.handleToggle, false);
        document.addEventListener('click', this.handleDropdown, false);
        Array.prototype.forEach.call(this.menu.querySelectorAll('a, button'), function (el) {
          el.addEventListener('blur', _this3.handleBlur, false);
        });
        document.addEventListener('keydown', this.handleKeyDown, false);
      }
    }]);

    return Menu;
  }();

  function getBoundingClientRect(element) {
    var rect = element.getBoundingClientRect();
    return {
      width: rect.width,
      height: rect.height,
      top: rect.top,
      right: rect.right,
      bottom: rect.bottom,
      left: rect.left,
      x: rect.left,
      y: rect.top
    };
  }

  /*:: import type { Window } from '../types'; */

  /*:: declare function getWindow(node: Node | Window): Window; */
  function getWindow(node) {
    if (node.toString() !== '[object Window]') {
      var ownerDocument = node.ownerDocument;
      return ownerDocument ? ownerDocument.defaultView : window;
    }

    return node;
  }

  function getWindowScroll(node) {
    var win = getWindow(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
      scrollLeft: scrollLeft,
      scrollTop: scrollTop
    };
  }

  /*:: declare function isElement(node: mixed): boolean %checks(node instanceof
    Element); */

  function isElement(node) {
    var OwnElement = getWindow(node).Element;
    return node instanceof OwnElement || node instanceof Element;
  }
  /*:: declare function isHTMLElement(node: mixed): boolean %checks(node instanceof
    HTMLElement); */


  function isHTMLElement(node) {
    var OwnElement = getWindow(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
  }

  function getHTMLElementScroll(element) {
    return {
      scrollLeft: element.scrollLeft,
      scrollTop: element.scrollTop
    };
  }

  function getNodeScroll(node) {
    if (node === getWindow(node) || !isHTMLElement(node)) {
      return getWindowScroll(node);
    } else {
      return getHTMLElementScroll(node);
    }
  }

  function getNodeName(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
  }

  function getDocumentElement(element) {
    // $FlowFixMe: assume body is always available
    return (isElement(element) ? element.ownerDocument : element.document).documentElement;
  }

  function getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
  }

  function getComputedStyle(element) {
    return getWindow(element).getComputedStyle(element);
  }

  function isScrollParent(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = getComputedStyle(element),
        overflow = _getComputedStyle.overflow,
        overflowX = _getComputedStyle.overflowX,
        overflowY = _getComputedStyle.overflowY;

    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
  }

  // Composite means it takes into account transforms as well as layout.

  function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) {
      isFixed = false;
    }

    var documentElement = getDocumentElement(offsetParent);
    var rect = getBoundingClientRect(elementOrVirtualElement);
    var isOffsetParentAnElement = isHTMLElement(offsetParent);
    var scroll = {
      scrollLeft: 0,
      scrollTop: 0
    };
    var offsets = {
      x: 0,
      y: 0
    };

    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
      if (getNodeName(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
      isScrollParent(documentElement)) {
        scroll = getNodeScroll(offsetParent);
      }

      if (isHTMLElement(offsetParent)) {
        offsets = getBoundingClientRect(offsetParent);
        offsets.x += offsetParent.clientLeft;
        offsets.y += offsetParent.clientTop;
      } else if (documentElement) {
        offsets.x = getWindowScrollBarX(documentElement);
      }
    }

    return {
      x: rect.left + scroll.scrollLeft - offsets.x,
      y: rect.top + scroll.scrollTop - offsets.y,
      width: rect.width,
      height: rect.height
    };
  }

  // Returns the layout rect of an element relative to its offsetParent. Layout
  // means it doesn't take into account transforms.
  function getLayoutRect(element) {
    return {
      x: element.offsetLeft,
      y: element.offsetTop,
      width: element.offsetWidth,
      height: element.offsetHeight
    };
  }

  function getParentNode(element) {
    if (getNodeName(element) === 'html') {
      return element;
    }

    return (// $FlowFixMe: this is a quicker (but less type safe) way to save quite some bytes from the bundle
      element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
      element.parentNode || // DOM Element detected
      // $FlowFixMe: need a better way to handle this...
      element.host || // ShadowRoot detected
      // $FlowFixMe: HTMLElement is a Node
      getDocumentElement(element) // fallback

    );
  }

  function getScrollParent(node) {
    if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
      // $FlowFixMe: assume body is always available
      return node.ownerDocument.body;
    }

    if (isHTMLElement(node) && isScrollParent(node)) {
      return node;
    }

    return getScrollParent(getParentNode(node));
  }

  /*
  given a DOM element, return the list of all scroll parents, up the list of ancesors
  until we get to the top window object. This list is what we attach scroll listeners
  to, because if any of these parent elements scroll, we'll need to re-calculate the 
  reference element's position.
  */

  function listScrollParents(element, list) {
    if (list === void 0) {
      list = [];
    }

    var scrollParent = getScrollParent(element);
    var isBody = getNodeName(scrollParent) === 'body';
    var win = getWindow(scrollParent);
    var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : // $FlowFixMe: isBody tells us target will be an HTMLElement here
    updatedList.concat(listScrollParents(getParentNode(target)));
  }

  function isTableElement(element) {
    return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
  }

  function getTrueOffsetParent(element) {
    if (!isHTMLElement(element) || // https://github.com/popperjs/popper-core/issues/837
    getComputedStyle(element).position === 'fixed') {
      return null;
    }

    return element.offsetParent;
  } // `.offsetParent` reports `null` for fixed elements, while absolute elements
  // return the containing block


  function getContainingBlock(element) {
    var currentNode = getParentNode(element);

    while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
      var css = getComputedStyle(currentNode); // This is non-exhaustive but covers the most common CSS properties that
      // create a containing block.

      if (css.transform !== 'none' || css.perspective !== 'none' || css.willChange !== 'auto') {
        return currentNode;
      } else {
        currentNode = currentNode.parentNode;
      }
    }

    return null;
  } // Gets the closest ancestor positioned element. Handles some edge cases,
  // such as table ancestors and cross browser bugs.


  function getOffsetParent(element) {
    var window = getWindow(element);
    var offsetParent = getTrueOffsetParent(element);

    while (offsetParent && isTableElement(offsetParent) && getComputedStyle(offsetParent).position === 'static') {
      offsetParent = getTrueOffsetParent(offsetParent);
    }

    if (offsetParent && getNodeName(offsetParent) === 'body' && getComputedStyle(offsetParent).position === 'static') {
      return window;
    }

    return offsetParent || getContainingBlock(element) || window;
  }

  var top = 'top';
  var bottom = 'bottom';
  var right = 'right';
  var left = 'left';
  var auto = 'auto';
  var basePlacements = [top, bottom, right, left];
  var start = 'start';
  var end = 'end';
  var clippingParents = 'clippingParents';
  var viewport = 'viewport';
  var popper = 'popper';
  var reference = 'reference';
  var variationPlacements =
  /*#__PURE__*/
  basePlacements.reduce(function (acc, placement) {
    return acc.concat([placement + "-" + start, placement + "-" + end]);
  }, []);
  var placements =
  /*#__PURE__*/
  [].concat(basePlacements, [auto]).reduce(function (acc, placement) {
    return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
  }, []); // modifiers that need to read the DOM

  var beforeRead = 'beforeRead';
  var read = 'read';
  var afterRead = 'afterRead'; // pure-logic modifiers

  var beforeMain = 'beforeMain';
  var main = 'main';
  var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

  var beforeWrite = 'beforeWrite';
  var write = 'write';
  var afterWrite = 'afterWrite';
  var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];

  function order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function (modifier) {
      map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively

    function sort(modifier) {
      visited.add(modifier.name);
      var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
      requires.forEach(function (dep) {
        if (!visited.has(dep)) {
          var depModifier = map.get(dep);

          if (depModifier) {
            sort(depModifier);
          }
        }
      });
      result.push(modifier);
    }

    modifiers.forEach(function (modifier) {
      if (!visited.has(modifier.name)) {
        // check for visited object
        sort(modifier);
      }
    });
    return result;
  }

  function orderModifiers(modifiers) {
    // order based on dependencies
    var orderedModifiers = order(modifiers); // order based on phase

    return modifierPhases.reduce(function (acc, phase) {
      return acc.concat(orderedModifiers.filter(function (modifier) {
        return modifier.phase === phase;
      }));
    }, []);
  }

  function debounce(fn) {
    var pending;
    return function () {
      if (!pending) {
        pending = new Promise(function (resolve) {
          Promise.resolve().then(function () {
            pending = undefined;
            resolve(fn());
          });
        });
      }

      return pending;
    };
  }

  function getBasePlacement(placement) {
    return placement.split('-')[0];
  }

  function mergeByName(modifiers) {
    var merged = modifiers.reduce(function (merged, current) {
      var existing = merged[current.name];
      merged[current.name] = existing ? Object.assign(Object.assign(Object.assign({}, existing), current), {}, {
        options: Object.assign(Object.assign({}, existing.options), current.options),
        data: Object.assign(Object.assign({}, existing.data), current.data)
      }) : current;
      return merged;
    }, {}); // IE11 does not support Object.values

    return Object.keys(merged).map(function (key) {
      return merged[key];
    });
  }

  var DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
  };

  function areValidElements() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return !args.some(function (element) {
      return !(element && typeof element.getBoundingClientRect === 'function');
    });
  }

  function popperGenerator(generatorOptions) {
    if (generatorOptions === void 0) {
      generatorOptions = {};
    }

    var _generatorOptions = generatorOptions,
        _generatorOptions$def = _generatorOptions.defaultModifiers,
        defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
        _generatorOptions$def2 = _generatorOptions.defaultOptions,
        defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
      if (options === void 0) {
        options = defaultOptions;
      }

      var state = {
        placement: 'bottom',
        orderedModifiers: [],
        options: Object.assign(Object.assign({}, DEFAULT_OPTIONS), defaultOptions),
        modifiersData: {},
        elements: {
          reference: reference,
          popper: popper
        },
        attributes: {},
        styles: {}
      };
      var effectCleanupFns = [];
      var isDestroyed = false;
      var instance = {
        state: state,
        setOptions: function setOptions(options) {
          cleanupModifierEffects();
          state.options = Object.assign(Object.assign(Object.assign({}, defaultOptions), state.options), options);
          state.scrollParents = {
            reference: isElement(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
            popper: listScrollParents(popper)
          }; // Orders the modifiers based on their dependencies and `phase`
          // properties

          var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

          state.orderedModifiers = orderedModifiers.filter(function (m) {
            return m.enabled;
          }); // Validate the provided modifiers so that the consumer will get warned

          runModifierEffects();
          return instance.update();
        },
        // Sync update – it will always be executed, even if not necessary. This
        // is useful for low frequency updates where sync behavior simplifies the
        // logic.
        // For high frequency updates (e.g. `resize` and `scroll` events), always
        // prefer the async Popper#update method
        forceUpdate: function forceUpdate() {
          if (isDestroyed) {
            return;
          }

          var _state$elements = state.elements,
              reference = _state$elements.reference,
              popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
          // anymore

          if (!areValidElements(reference, popper)) {

            return;
          } // Store the reference and popper rects to be read by modifiers


          state.rects = {
            reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
            popper: getLayoutRect(popper)
          }; // Modifiers have the ability to reset the current update cycle. The
          // most common use case for this is the `flip` modifier changing the
          // placement, which then needs to re-run all the modifiers, because the
          // logic was previously ran for the previous placement and is therefore
          // stale/incorrect

          state.reset = false;
          state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
          // is filled with the initial data specified by the modifier. This means
          // it doesn't persist and is fresh on each update.
          // To ensure persistent data, use `${name}#persistent`

          state.orderedModifiers.forEach(function (modifier) {
            return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
          });

          for (var index = 0; index < state.orderedModifiers.length; index++) {

            if (state.reset === true) {
              state.reset = false;
              index = -1;
              continue;
            }

            var _state$orderedModifie = state.orderedModifiers[index],
                fn = _state$orderedModifie.fn,
                _state$orderedModifie2 = _state$orderedModifie.options,
                _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
                name = _state$orderedModifie.name;

            if (typeof fn === 'function') {
              state = fn({
                state: state,
                options: _options,
                name: name,
                instance: instance
              }) || state;
            }
          }
        },
        // Async and optimistically optimized update – it will not be executed if
        // not necessary (debounced to run at most once-per-tick)
        update: debounce(function () {
          return new Promise(function (resolve) {
            instance.forceUpdate();
            resolve(state);
          });
        }),
        destroy: function destroy() {
          cleanupModifierEffects();
          isDestroyed = true;
        }
      };

      if (!areValidElements(reference, popper)) {

        return instance;
      }

      instance.setOptions(options).then(function (state) {
        if (!isDestroyed && options.onFirstUpdate) {
          options.onFirstUpdate(state);
        }
      }); // Modifiers have the ability to execute arbitrary code before the first
      // update cycle runs. They will be executed in the same order as the update
      // cycle. This is useful when a modifier adds some persistent data that
      // other modifiers need to use, but the modifier is run after the dependent
      // one.

      function runModifierEffects() {
        state.orderedModifiers.forEach(function (_ref3) {
          var name = _ref3.name,
              _ref3$options = _ref3.options,
              options = _ref3$options === void 0 ? {} : _ref3$options,
              effect = _ref3.effect;

          if (typeof effect === 'function') {
            var cleanupFn = effect({
              state: state,
              name: name,
              instance: instance,
              options: options
            });

            var noopFn = function noopFn() {};

            effectCleanupFns.push(cleanupFn || noopFn);
          }
        });
      }

      function cleanupModifierEffects() {
        effectCleanupFns.forEach(function (fn) {
          return fn();
        });
        effectCleanupFns = [];
      }

      return instance;
    };
  }

  var passive = {
    passive: true
  };

  function effect(_ref) {
    var state = _ref.state,
        instance = _ref.instance,
        options = _ref.options;
    var _options$scroll = options.scroll,
        scroll = _options$scroll === void 0 ? true : _options$scroll,
        _options$resize = options.resize,
        resize = _options$resize === void 0 ? true : _options$resize;
    var window = getWindow(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.addEventListener('resize', instance.update, passive);
    }

    return function () {
      if (scroll) {
        scrollParents.forEach(function (scrollParent) {
          scrollParent.removeEventListener('scroll', instance.update, passive);
        });
      }

      if (resize) {
        window.removeEventListener('resize', instance.update, passive);
      }
    };
  } // eslint-disable-next-line import/no-unused-modules


  var eventListeners = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: effect,
    data: {}
  };

  function getVariation(placement) {
    return placement.split('-')[1];
  }

  function getMainAxisFromPlacement(placement) {
    return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
  }

  function computeOffsets(_ref) {
    var reference = _ref.reference,
        element = _ref.element,
        placement = _ref.placement;
    var basePlacement = placement ? getBasePlacement(placement) : null;
    var variation = placement ? getVariation(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;

    switch (basePlacement) {
      case top:
        offsets = {
          x: commonX,
          y: reference.y - element.height
        };
        break;

      case bottom:
        offsets = {
          x: commonX,
          y: reference.y + reference.height
        };
        break;

      case right:
        offsets = {
          x: reference.x + reference.width,
          y: commonY
        };
        break;

      case left:
        offsets = {
          x: reference.x - element.width,
          y: commonY
        };
        break;

      default:
        offsets = {
          x: reference.x,
          y: reference.y
        };
    }

    var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;

    if (mainAxis != null) {
      var len = mainAxis === 'y' ? 'height' : 'width';

      switch (variation) {
        case start:
          offsets[mainAxis] = Math.floor(offsets[mainAxis]) - Math.floor(reference[len] / 2 - element[len] / 2);
          break;

        case end:
          offsets[mainAxis] = Math.floor(offsets[mainAxis]) + Math.ceil(reference[len] / 2 - element[len] / 2);
          break;
      }
    }

    return offsets;
  }

  function popperOffsets(_ref) {
    var state = _ref.state,
        name = _ref.name; // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step

    state.modifiersData[name] = computeOffsets({
      reference: state.rects.reference,
      element: state.rects.popper,
      strategy: 'absolute',
      placement: state.placement
    });
  } // eslint-disable-next-line import/no-unused-modules


  var popperOffsets$1 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: popperOffsets,
    data: {}
  };

  var unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
  }; // Round the offsets to the nearest suitable subpixel based on the DPR.
  // Zooming can change the DPR, but it seems to report a value that will
  // cleanly divide the values into the appropriate subpixels.

  function roundOffsets(_ref) {
    var x = _ref.x,
        y = _ref.y;
    var win = window;
    var dpr = win.devicePixelRatio || 1;
    return {
      x: Math.round(x * dpr) / dpr || 0,
      y: Math.round(y * dpr) / dpr || 0
    };
  }

  function mapToStyles(_ref2) {
    var _Object$assign2;

    var popper = _ref2.popper,
        popperRect = _ref2.popperRect,
        placement = _ref2.placement,
        offsets = _ref2.offsets,
        position = _ref2.position,
        gpuAcceleration = _ref2.gpuAcceleration,
        adaptive = _ref2.adaptive;

    var _roundOffsets = roundOffsets(offsets),
        x = _roundOffsets.x,
        y = _roundOffsets.y;

    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = left;
    var sideY = top;
    var win = window;

    if (adaptive) {
      var offsetParent = getOffsetParent(popper);

      if (offsetParent === getWindow(popper)) {
        offsetParent = getDocumentElement(popper);
      } // $FlowFixMe: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it

      /*:: offsetParent = (offsetParent: Element); */


      if (placement === top) {
        sideY = bottom;
        y -= offsetParent.clientHeight - popperRect.height;
        y *= gpuAcceleration ? 1 : -1;
      }

      if (placement === left) {
        sideX = right;
        x -= offsetParent.clientWidth - popperRect.width;
        x *= gpuAcceleration ? 1 : -1;
      }
    }

    var commonStyles = Object.assign({
      position: position
    }, adaptive && unsetSides);

    if (gpuAcceleration) {
      var _Object$assign;

      return Object.assign(Object.assign({}, commonStyles), {}, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) < 2 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }

    return Object.assign(Object.assign({}, commonStyles), {}, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
  }

  function computeStyles(_ref3) {
    var state = _ref3.state,
        options = _ref3.options;
    var _options$gpuAccelerat = options.gpuAcceleration,
        gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
        _options$adaptive = options.adaptive,
        adaptive = _options$adaptive === void 0 ? true : _options$adaptive;

    var commonStyles = {
      placement: getBasePlacement(state.placement),
      popper: state.elements.popper,
      popperRect: state.rects.popper,
      gpuAcceleration: gpuAcceleration
    };

    if (state.modifiersData.popperOffsets != null) {
      state.styles.popper = Object.assign(Object.assign({}, state.styles.popper), mapToStyles(Object.assign(Object.assign({}, commonStyles), {}, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive
      })));
    }

    if (state.modifiersData.arrow != null) {
      state.styles.arrow = Object.assign(Object.assign({}, state.styles.arrow), mapToStyles(Object.assign(Object.assign({}, commonStyles), {}, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false
      })));
    }

    state.attributes.popper = Object.assign(Object.assign({}, state.attributes.popper), {}, {
      'data-popper-placement': state.placement
    });
  } // eslint-disable-next-line import/no-unused-modules


  var computeStyles$1 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: computeStyles,
    data: {}
  };

  // and applies them to the HTMLElements such as popper and arrow

  function applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function (name) {
      var style = state.styles[name] || {};
      var attributes = state.attributes[name] || {};
      var element = state.elements[name]; // arrow is optional + virtual elements

      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      } // Flow doesn't support to extend this property, but it's the most
      // effective way to apply styles to an HTMLElement
      // $FlowFixMe


      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (name) {
        var value = attributes[name];

        if (value === false) {
          element.removeAttribute(name);
        } else {
          element.setAttribute(name, value === true ? '' : value);
        }
      });
    });
  }

  function effect$1(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
      popper: {
        position: state.options.strategy,
        left: '0',
        top: '0',
        margin: '0'
      },
      arrow: {
        position: 'absolute'
      },
      reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);

    if (state.elements.arrow) {
      Object.assign(state.elements.arrow.style, initialStyles.arrow);
    }

    return function () {
      Object.keys(state.elements).forEach(function (name) {
        var element = state.elements[name];
        var attributes = state.attributes[name] || {};
        var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

        var style = styleProperties.reduce(function (style, property) {
          style[property] = '';
          return style;
        }, {}); // arrow is optional + virtual elements

        if (!isHTMLElement(element) || !getNodeName(element)) {
          return;
        } // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe


        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function (attribute) {
          element.removeAttribute(attribute);
        });
      });
    };
  } // eslint-disable-next-line import/no-unused-modules


  var applyStyles$1 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: applyStyles,
    effect: effect$1,
    requires: ['computeStyles']
  };

  function distanceAndSkiddingToXY(placement, rects, offset) {
    var basePlacement = getBasePlacement(placement);
    var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;

    var _ref = typeof offset === 'function' ? offset(Object.assign(Object.assign({}, rects), {}, {
      placement: placement
    })) : offset,
        skidding = _ref[0],
        distance = _ref[1];

    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [left, right].indexOf(basePlacement) >= 0 ? {
      x: distance,
      y: skidding
    } : {
      x: skidding,
      y: distance
    };
  }

  function offset(_ref2) {
    var state = _ref2.state,
        options = _ref2.options,
        name = _ref2.name;
    var _options$offset = options.offset,
        offset = _options$offset === void 0 ? [0, 0] : _options$offset;
    var data = placements.reduce(function (acc, placement) {
      acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
      return acc;
    }, {});
    var _data$state$placement = data[state.placement],
        x = _data$state$placement.x,
        y = _data$state$placement.y;

    if (state.modifiersData.popperOffsets != null) {
      state.modifiersData.popperOffsets.x += x;
      state.modifiersData.popperOffsets.y += y;
    }

    state.modifiersData[name] = data;
  } // eslint-disable-next-line import/no-unused-modules


  var offset$1 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: ['popperOffsets'],
    fn: offset
  };

  var hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
  };
  function getOppositePlacement(placement) {
    return placement.replace(/left|right|bottom|top/g, function (matched) {
      return hash[matched];
    });
  }

  var hash$1 = {
    start: 'end',
    end: 'start'
  };
  function getOppositeVariationPlacement(placement) {
    return placement.replace(/start|end/g, function (matched) {
      return hash$1[matched];
    });
  }

  function getViewportRect(element) {
    var win = getWindow(element);
    var html = getDocumentElement(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0; // NB: This isn't supported on iOS <= 12. If the keyboard is open, the popper
    // can be obscured underneath it.
    // Also, `html.clientHeight` adds the bottom bar height in Safari iOS, even
    // if it isn't open, so if this isn't available, the popper will be detected
    // to overflow the bottom of the screen too early.

    if (visualViewport) {
      width = visualViewport.width;
      height = visualViewport.height; // Uses Layout Viewport (like Chrome; Safari does not currently)
      // In Chrome, it returns a value very close to 0 (+/-) but contains rounding
      // errors due to floating point numbers, so we need to check precision.
      // Safari returns a number <= 0, usually < -1 when pinch-zoomed
      // Feature detection fails in mobile emulation mode in Chrome.
      // Math.abs(win.innerWidth / visualViewport.scale - visualViewport.width) <
      // 0.001
      // Fallback here: "Not Safari" userAgent

      if (!/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
        x = visualViewport.offsetLeft;
        y = visualViewport.offsetTop;
      }
    }

    return {
      width: width,
      height: height,
      x: x + getWindowScrollBarX(element),
      y: y
    };
  }

  // of the `<html>` and `<body>` rect bounds if horizontally scrollable

  function getDocumentRect(element) {
    var html = getDocumentElement(element);
    var winScroll = getWindowScroll(element);
    var body = element.ownerDocument.body;
    var width = Math.max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = Math.max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
    var y = -winScroll.scrollTop;

    if (getComputedStyle(body || html).direction === 'rtl') {
      x += Math.max(html.clientWidth, body ? body.clientWidth : 0) - width;
    }

    return {
      width: width,
      height: height,
      x: x,
      y: y
    };
  }

  function contains(parent, child) {
    // $FlowFixMe: hasOwnProperty doesn't seem to work in tests
    var isShadow = Boolean(child.getRootNode && child.getRootNode().host); // First, attempt with faster native method

    if (parent.contains(child)) {
      return true;
    } // then fallback to custom implementation with Shadow DOM support
    else if (isShadow) {
        var next = child;

        do {
          if (next && parent.isSameNode(next)) {
            return true;
          } // $FlowFixMe: need a better way to handle this...


          next = next.parentNode || next.host;
        } while (next);
      } // Give up, the result is false


    return false;
  }

  function rectToClientRect(rect) {
    return Object.assign(Object.assign({}, rect), {}, {
      left: rect.x,
      top: rect.y,
      right: rect.x + rect.width,
      bottom: rect.y + rect.height
    });
  }

  function getInnerBoundingClientRect(element) {
    var rect = getBoundingClientRect(element);
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
  }

  function getClientRectFromMixedType(element, clippingParent) {
    return clippingParent === viewport ? rectToClientRect(getViewportRect(element)) : isHTMLElement(clippingParent) ? getInnerBoundingClientRect(clippingParent) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
  } // A "clipping parent" is an overflowable container with the characteristic of
  // clipping (or hiding) overflowing elements with a position different from
  // `initial`


  function getClippingParents(element) {
    var clippingParents = listScrollParents(element);
    var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle(element).position) >= 0;
    var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;

    if (!isElement(clipperElement)) {
      return [];
    } // $FlowFixMe: https://github.com/facebook/flow/issues/1414


    return clippingParents.filter(function (clippingParent) {
      return isElement(clippingParent) && contains(clippingParent, clipperElement);
    });
  } // Gets the maximum area that the element is visible in due to any number of
  // clipping parents


  function getClippingRect(element, boundary, rootBoundary) {
    var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
      var rect = getClientRectFromMixedType(element, clippingParent);
      accRect.top = Math.max(rect.top, accRect.top);
      accRect.right = Math.min(rect.right, accRect.right);
      accRect.bottom = Math.min(rect.bottom, accRect.bottom);
      accRect.left = Math.max(rect.left, accRect.left);
      return accRect;
    }, getClientRectFromMixedType(element, firstClippingParent));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
  }

  function getFreshSideObject() {
    return {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    };
  }

  function mergePaddingObject(paddingObject) {
    return Object.assign(Object.assign({}, getFreshSideObject()), paddingObject);
  }

  function expandToHashMap(value, keys) {
    return keys.reduce(function (hashMap, key) {
      hashMap[key] = value;
      return hashMap;
    }, {});
  }

  function detectOverflow(state, options) {
    if (options === void 0) {
      options = {};
    }

    var _options = options,
        _options$placement = _options.placement,
        placement = _options$placement === void 0 ? state.placement : _options$placement,
        _options$boundary = _options.boundary,
        boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
        _options$rootBoundary = _options.rootBoundary,
        rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
        _options$elementConte = _options.elementContext,
        elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
        _options$altBoundary = _options.altBoundary,
        altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
        _options$padding = _options.padding,
        padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
    var altContext = elementContext === popper ? reference : popper;
    var referenceElement = state.elements.reference;
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary);
    var referenceClientRect = getBoundingClientRect(referenceElement);
    var popperOffsets = computeOffsets({
      reference: referenceClientRect,
      element: popperRect,
      strategy: 'absolute',
      placement: placement
    });
    var popperClientRect = rectToClientRect(Object.assign(Object.assign({}, popperRect), popperOffsets));
    var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect

    var overflowOffsets = {
      top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
      bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
      left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
      right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

    if (elementContext === popper && offsetData) {
      var offset = offsetData[placement];
      Object.keys(overflowOffsets).forEach(function (key) {
        var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
        var axis = [top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
        overflowOffsets[key] += offset[axis] * multiply;
      });
    }

    return overflowOffsets;
  }

  /*:: type OverflowsMap = { [ComputedPlacement]: number }; */

  /*;; type OverflowsMap = { [key in ComputedPlacement]: number }; */

  function computeAutoPlacement(state, options) {
    if (options === void 0) {
      options = {};
    }

    var _options = options,
        placement = _options.placement,
        boundary = _options.boundary,
        rootBoundary = _options.rootBoundary,
        padding = _options.padding,
        flipVariations = _options.flipVariations,
        _options$allowedAutoP = _options.allowedAutoPlacements,
        allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
    var variation = getVariation(placement);
    var placements$1 = (variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
      return getVariation(placement) === variation;
    }) : basePlacements).filter(function (placement) {
      return allowedAutoPlacements.indexOf(placement) >= 0;
    }); // $FlowFixMe: Flow seems to have problems with two array unions...

    var overflows = placements$1.reduce(function (acc, placement) {
      acc[placement] = detectOverflow(state, {
        placement: placement,
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding
      })[getBasePlacement(placement)];
      return acc;
    }, {});
    return Object.keys(overflows).sort(function (a, b) {
      return overflows[a] - overflows[b];
    });
  }

  function getExpandedFallbackPlacements(placement) {
    if (getBasePlacement(placement) === auto) {
      return [];
    }

    var oppositePlacement = getOppositePlacement(placement);
    return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
  }

  function flip(_ref) {
    var state = _ref.state,
        options = _ref.options,
        name = _ref.name;

    if (state.modifiersData[name]._skip) {
      return;
    }

    var _options$mainAxis = options.mainAxis,
        checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
        _options$altAxis = options.altAxis,
        checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
        specifiedFallbackPlacements = options.fallbackPlacements,
        padding = options.padding,
        boundary = options.boundary,
        rootBoundary = options.rootBoundary,
        altBoundary = options.altBoundary,
        _options$flipVariatio = options.flipVariations,
        flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
        allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = getBasePlacement(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
    var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
      return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
        placement: placement,
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        flipVariations: flipVariations,
        allowedAutoPlacements: allowedAutoPlacements
      }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];

    for (var i = 0; i < placements.length; i++) {
      var placement = placements[i];

      var _basePlacement = getBasePlacement(placement);

      var isStartVariation = getVariation(placement) === start;
      var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
      var len = isVertical ? 'width' : 'height';
      var overflow = detectOverflow(state, {
        placement: placement,
        boundary: boundary,
        rootBoundary: rootBoundary,
        altBoundary: altBoundary,
        padding: padding
      });
      var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;

      if (referenceRect[len] > popperRect[len]) {
        mainVariationSide = getOppositePlacement(mainVariationSide);
      }

      var altVariationSide = getOppositePlacement(mainVariationSide);
      var checks = [];

      if (checkMainAxis) {
        checks.push(overflow[_basePlacement] <= 0);
      }

      if (checkAltAxis) {
        checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
      }

      if (checks.every(function (check) {
        return check;
      })) {
        firstFittingPlacement = placement;
        makeFallbackChecks = false;
        break;
      }

      checksMap.set(placement, checks);
    }

    if (makeFallbackChecks) {
      // `2` may be desired in some cases – research later
      var numberOfChecks = flipVariations ? 3 : 1;

      var _loop = function _loop(_i) {
        var fittingPlacement = placements.find(function (placement) {
          var checks = checksMap.get(placement);

          if (checks) {
            return checks.slice(0, _i).every(function (check) {
              return check;
            });
          }
        });

        if (fittingPlacement) {
          firstFittingPlacement = fittingPlacement;
          return "break";
        }
      };

      for (var _i = numberOfChecks; _i > 0; _i--) {
        var _ret = _loop(_i);

        if (_ret === "break") break;
      }
    }

    if (state.placement !== firstFittingPlacement) {
      state.modifiersData[name]._skip = true;
      state.placement = firstFittingPlacement;
      state.reset = true;
    }
  } // eslint-disable-next-line import/no-unused-modules


  var flip$1 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: flip,
    requiresIfExists: ['offset'],
    data: {
      _skip: false
    }
  };

  function getAltAxis(axis) {
    return axis === 'x' ? 'y' : 'x';
  }

  function within(min, value, max) {
    return Math.max(min, Math.min(value, max));
  }

  function preventOverflow(_ref) {
    var state = _ref.state,
        options = _ref.options,
        name = _ref.name;
    var _options$mainAxis = options.mainAxis,
        checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
        _options$altAxis = options.altAxis,
        checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
        boundary = options.boundary,
        rootBoundary = options.rootBoundary,
        altBoundary = options.altBoundary,
        padding = options.padding,
        _options$tether = options.tether,
        tether = _options$tether === void 0 ? true : _options$tether,
        _options$tetherOffset = options.tetherOffset,
        tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = detectOverflow(state, {
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      altBoundary: altBoundary
    });
    var basePlacement = getBasePlacement(state.placement);
    var variation = getVariation(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = getMainAxisFromPlacement(basePlacement);
    var altAxis = getAltAxis(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign(Object.assign({}, state.rects), {}, {
      placement: state.placement
    })) : tetherOffset;
    var data = {
      x: 0,
      y: 0
    };

    if (!popperOffsets) {
      return;
    }

    if (checkMainAxis) {
      var mainSide = mainAxis === 'y' ? top : left;
      var altSide = mainAxis === 'y' ? bottom : right;
      var len = mainAxis === 'y' ? 'height' : 'width';
      var offset = popperOffsets[mainAxis];
      var min = popperOffsets[mainAxis] + overflow[mainSide];
      var max = popperOffsets[mainAxis] - overflow[altSide];
      var additive = tether ? -popperRect[len] / 2 : 0;
      var minLen = variation === start ? referenceRect[len] : popperRect[len];
      var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
      // outside the reference bounds

      var arrowElement = state.elements.arrow;
      var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
        width: 0,
        height: 0
      };
      var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
      var arrowPaddingMin = arrowPaddingObject[mainSide];
      var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
      // to include its full size in the calculation. If the reference is small
      // and near the edge of a boundary, the popper can overflow even if the
      // reference is not overflowing as well (e.g. virtual elements with no
      // width or height)

      var arrowLen = within(0, referenceRect[len], arrowRect[len]);
      var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - tetherOffsetValue : minLen - arrowLen - arrowPaddingMin - tetherOffsetValue;
      var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + tetherOffsetValue : maxLen + arrowLen + arrowPaddingMax + tetherOffsetValue;
      var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
      var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
      var offsetModifierValue = state.modifiersData.offset ? state.modifiersData.offset[state.placement][mainAxis] : 0;
      var tetherMin = popperOffsets[mainAxis] + minOffset - offsetModifierValue - clientOffset;
      var tetherMax = popperOffsets[mainAxis] + maxOffset - offsetModifierValue;
      var preventedOffset = within(tether ? Math.min(min, tetherMin) : min, offset, tether ? Math.max(max, tetherMax) : max);
      popperOffsets[mainAxis] = preventedOffset;
      data[mainAxis] = preventedOffset - offset;
    }

    if (checkAltAxis) {
      var _mainSide = mainAxis === 'x' ? top : left;

      var _altSide = mainAxis === 'x' ? bottom : right;

      var _offset = popperOffsets[altAxis];

      var _min = _offset + overflow[_mainSide];

      var _max = _offset - overflow[_altSide];

      var _preventedOffset = within(_min, _offset, _max);

      popperOffsets[altAxis] = _preventedOffset;
      data[altAxis] = _preventedOffset - _offset;
    }

    state.modifiersData[name] = data;
  } // eslint-disable-next-line import/no-unused-modules


  var preventOverflow$1 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: preventOverflow,
    requiresIfExists: ['offset']
  };

  function arrow(_ref) {
    var _state$modifiersData$;

    var state = _ref.state,
        name = _ref.name;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = getBasePlacement(state.placement);
    var axis = getMainAxisFromPlacement(basePlacement);
    var isVertical = [left, right].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';

    if (!arrowElement || !popperOffsets) {
      return;
    }

    var paddingObject = state.modifiersData[name + "#persistent"].padding;
    var arrowRect = getLayoutRect(arrowElement);
    var minProp = axis === 'y' ? top : left;
    var maxProp = axis === 'y' ? bottom : right;
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = getOffsetParent(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds

    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = within(min, center, max); // Prevents breaking syntax highlighting...

    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
  }

  function effect$2(_ref2) {
    var state = _ref2.state,
        options = _ref2.options,
        name = _ref2.name;
    var _options$element = options.element,
        arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element,
        _options$padding = options.padding,
        padding = _options$padding === void 0 ? 0 : _options$padding;

    if (arrowElement == null) {
      return;
    } // CSS selector


    if (typeof arrowElement === 'string') {
      arrowElement = state.elements.popper.querySelector(arrowElement);

      if (!arrowElement) {
        return;
      }
    }

    if (!contains(state.elements.popper, arrowElement)) {

      return;
    }

    state.elements.arrow = arrowElement;
    state.modifiersData[name + "#persistent"] = {
      padding: mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements))
    };
  } // eslint-disable-next-line import/no-unused-modules


  var arrow$1 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: arrow,
    effect: effect$2,
    requires: ['popperOffsets'],
    requiresIfExists: ['preventOverflow']
  };

  function getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) {
      preventedOffsets = {
        x: 0,
        y: 0
      };
    }

    return {
      top: overflow.top - rect.height - preventedOffsets.y,
      right: overflow.right - rect.width + preventedOffsets.x,
      bottom: overflow.bottom - rect.height + preventedOffsets.y,
      left: overflow.left - rect.width - preventedOffsets.x
    };
  }

  function isAnySideFullyClipped(overflow) {
    return [top, right, bottom, left].some(function (side) {
      return overflow[side] >= 0;
    });
  }

  function hide(_ref) {
    var state = _ref.state,
        name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = detectOverflow(state, {
      elementContext: 'reference'
    });
    var popperAltOverflow = detectOverflow(state, {
      altBoundary: true
    });
    var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
      referenceClippingOffsets: referenceClippingOffsets,
      popperEscapeOffsets: popperEscapeOffsets,
      isReferenceHidden: isReferenceHidden,
      hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign(Object.assign({}, state.attributes.popper), {}, {
      'data-popper-reference-hidden': isReferenceHidden,
      'data-popper-escaped': hasPopperEscaped
    });
  } // eslint-disable-next-line import/no-unused-modules


  var hide$1 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: ['preventOverflow'],
    fn: hide
  };

  var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$1, preventOverflow$1, arrow$1, hide$1];
  var createPopper =
  /*#__PURE__*/
  popperGenerator({
    defaultModifiers: defaultModifiers
  }); // eslint-disable-next-line import/no-unused-modules

  /**
   * Menu Button class.
   */

  var MenuButton =
  /*#__PURE__*/
  function () {
    /**
     * Constructor.
     *
     * @param {DomNode} container
     * @param {Object} options
     */
    function MenuButton(container, options) {
      _classCallCheck(this, MenuButton);

      this.container = container;
      this.label = this.container.querySelector('.menu-button__label');
      this.config = _objectSpread2(_objectSpread2({}, {
        placement: 'auto',
        preventOverflow: true,
        boundariesElement: document.querySelector('main')
      }), options);

      var _this$initMenuButton = this.initMenuButton(),
          btn = _this$initMenuButton.btn,
          menu = _this$initMenuButton.menu;

      this.btn = btn;
      this.menu = menu;
      this.links = this.menu.querySelectorAll('a');
      this.handleClick = this.handleClick.bind(this);
      this.handleKeyDown = this.handleKeyDown.bind(this);
      this.handleBlur = this.handleBlur.bind(this);
      this.addEventListeners();
    }
    /**
     * Create the dynamic menu button.
     */


    _createClass(MenuButton, [{
      key: "initMenuButton",
      value: function initMenuButton() {
        // Create button
        var btn = document.createElement('button');
        btn.setAttribute('aria-expanded', 'false');
        btn.setAttribute('class', 'button button--borderless');
        btn.innerHTML = this.label.innerHTML;
        this.container.insertBefore(btn, this.label);
        this.container.removeChild(this.label); // Wrap menu

        var linkList = this.container.querySelector('.link-list');
        var menu = document.createElement('div');
        var menuList = document.createElement('ul');
        var arrow = document.createElement('span');
        menu.classList.add('menu-button__menu');
        arrow.classList.add('menu-button__menu__arrow');
        arrow.setAttribute('data-popper-arrow', '');
        menuList.innerHTML = linkList.innerHTML;
        Array.prototype.forEach.call(menuList.children, function (menuItem) {
          menuItem.removeAttribute('class');
        });
        menu.insertBefore(menuList, menu.firstChild);
        menu.insertBefore(arrow, menu.firstChild);
        this.container.insertBefore(menu, linkList);
        this.container.removeChild(linkList);
        return {
          btn: btn,
          menu: menu
        };
      }
      /**
       * Handle click.
       *
       * @param {Event} event
       */

    }, {
      key: "handleClick",
      value: function handleClick(event) {
        if (event.target.parentNode != this.container) {
          this.btn.setAttribute('aria-expanded', false);
        } else {
          var expanded = 'true' === this.btn.getAttribute('aria-expanded') || false;
          this.btn.setAttribute('aria-expanded', !expanded);

          if (false === expanded) {
            createPopper(this.btn, this.menu, {
              placement: this.config.placement,
              preventOverflow: true === this.config.preventOverflow ? {
                enabled: true,
                boundariesElement: this.config.boundariesElement
              } : {
                enabled: false
              },
              modifiers: [{
                name: 'offset',
                options: {
                  offset: [0, 20]
                }
              }]
            });
          }
        }
      }
      /**
       * Handle blur.
       *
       * @param {Event} event
       */

    }, {
      key: "handleBlur",
      value: function handleBlur(event) {
        if (event.target === this.links[this.links.length - 1] && event.relatedTarget && 'LI' !== event.relatedTarget.parentNode.nodeName) {
          this.btn.setAttribute('aria-expanded', false);
        }
      }
      /**
       * Handle keydown.
       *
       * @param {Event} event
       */

    }, {
      key: "handleKeyDown",
      value: function handleKeyDown(event) {
        if (27 === event.keyCode) {
          var restoreFocus = document.activeElement.closest('.menu-button') === this.btn.parentNode;
          this.btn.setAttribute('aria-expanded', false);
          if (restoreFocus) this.btn.focus();
        }
      }
      /**
       * Add event listeners.
       */

    }, {
      key: "addEventListeners",
      value: function addEventListeners() {
        var _this = this;

        document.addEventListener('click', this.handleClick);
        document.addEventListener('keydown', this.handleKeyDown, false);
        Array.prototype.forEach.call(this.links, function (link) {
          link.addEventListener('blur', _this.handleBlur, false);
        });
      }
    }]);

    return MenuButton;
  }();

  /**
   * Mixed checkbox class.
   */
  var NestedCheckbox =
  /*#__PURE__*/
  function () {
    /**
     * Constructor.
     *
     * @param {DomNode} container
     * @param {DomNode} input
     * @param {NodeList} subInputs
     * @param {Object} options
     */
    function NestedCheckbox(container, input, subInputs, options) {
      _classCallCheck(this, NestedCheckbox);

      this.container = container;
      this.input = input;
      this.inputId = this.input.id;
      this.customCheckbox = false;
      this.value = this.input.getAttribute('value');
      this.label = this.container.querySelector("label[for=\"".concat(this.inputId, "\"]"));
      this.subInputs = subInputs;
      this.subGroup = this.container.querySelector('.input-group__descendant');
      this.config = _objectSpread2(_objectSpread2({}, {
        disclosureButtonSelector: '.disclosure-button'
      }), options);
      this.initCustomCheckbox();
      this.handleChange = this.handleChange.bind(this);
      this.handleClick = this.handleClick.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
      this.addEventListeners();
    }
    /**
     * Initialize a mixed checkbox.
     */


    _createClass(NestedCheckbox, [{
      key: "initCustomCheckbox",
      value: function initCustomCheckbox() {
        var status = this.getCustomState();
        var supplementaryLabel = this.container.querySelector('span.supplementary-label');
        var customCheckbox = document.createElement('div');
        customCheckbox.classList.add('checkbox');
        customCheckbox.setAttribute('role', 'checkbox');
        customCheckbox.setAttribute('aria-checked', status);
        customCheckbox.setAttribute('tabindex', 0);
        customCheckbox.textContent = this.label.innerText;

        if (supplementaryLabel) {
          supplementaryLabel.parentNode.removeChild(supplementaryLabel);
          customCheckbox.appendChild(supplementaryLabel);
          supplementaryLabel.classList.add('screen-reader-text');
          supplementaryLabel.hidden = false;
        }

        this.label.parentNode.insertBefore(customCheckbox, this.label);
        this.input.classList.add('screen-reader-text');
        this.input.setAttribute('aria-hidden', 'true');
        this.label.hidden = true;
        this.customCheckbox = customCheckbox;
      }
      /**
       * Get custom status for the top-level checkbox.
       */

    }, {
      key: "getCustomState",
      value: function getCustomState() {
        var checkedSubInputs = this.subGroup.querySelectorAll('[type="checkbox"]:checked');
        var state = false;

        if (checkedSubInputs.length === this.subInputs.length) {
          state = true;
        } else if (0 < checkedSubInputs.length) {
          state = 'mixed';
        }

        return state;
      }
      /**
       * Handler for mixed checkboxes.
       *
       * @param {DomNode} ctrl
       */

    }, {
      key: "toggleMixedCheckbox",
      value: function toggleMixedCheckbox(ctrl) {
        var state = 'true' === ctrl.getAttribute('aria-checked') || false;
        ctrl.setAttribute('aria-checked', !state);
        this.input.checked = !state;
        Array.prototype.forEach.call(this.subInputs, function (checkbox) {
          checkbox.checked = !state;
        });
        ctrl.focus();
      }
      /**
       * Handle change event.
       *
       * @param {Event} event
       */

    }, {
      key: "handleChange",
      value: function handleChange(event) {
        if (!this.subGroup.contains(event.target)) return;
        var checkedSubInputs = this.subGroup.querySelectorAll('[type="checkbox"]:checked');
        var state = false;

        if (event.target.checked) {
          if (checkedSubInputs.length === this.subInputs.length) {
            state = true;
          } else {
            state = 'mixed';
          }
        } else {
          if (0 < checkedSubInputs.length) {
            state = 'mixed';
          } else {
            state = false;
          }
        }

        this.customCheckbox.setAttribute('aria-checked', state);
        this.input.setAttribute('value', true === state ? this.value : '');
      }
      /**
       *
       * @param {Event} event
       */

    }, {
      key: "handleClick",
      value: function handleClick(event) {
        if ('checkbox' !== event.target.getAttribute('role')) return;

        if ('checkbox' === event.target.getAttribute('role')) {
          this.toggleMixedCheckbox(event.target);
        }
      }
      /**
       * Handle keydown event.
       *
       * @param {Event} event
       */

    }, {
      key: "handleKeydown",
      value: function handleKeydown(event) {
        if ('checkbox' !== event.target.getAttribute('role')) {
          return;
        }

        var flag = false;

        if (32 === event.keyCode) {
          this.toggleMixedCheckbox(event.target);
          flag = true;
        }

        if (flag) {
          event.stopPropagation();
          event.preventDefault();
        }
      }
      /**
       * Add event listeners.
       */

    }, {
      key: "addEventListeners",
      value: function addEventListeners() {
        this.container.addEventListener('change', this.handleChange, false);
        this.container.addEventListener('click', this.handleClick, false);
        this.container.addEventListener('keydown', this.handleKeydown, false);
      }
    }]);

    return NestedCheckbox;
  }();

  /**
   * Notification class.
   */
  var Notification =
  /*#__PURE__*/
  function () {
    /**
     * Constructor.
     *
     * @param {Object} options
     */
    function Notification(options) {
      _classCallCheck(this, Notification);

      this.config = _objectSpread2(_objectSpread2({}, {}), options);
      this.handleClick = this.handleClick.bind(this);
      this.addEventListeners();
    }
    /**
     * Handle click.
     *
     * @param {Event} event
     */


    _createClass(Notification, [{
      key: "handleClick",
      value: function handleClick(event) {
        if (event.target.closest('.notification button')) {
          var notification = event.target.closest('.notification');
          notification.parentNode.removeChild(notification);
        }
      }
      /**
       * Add event listeners.
       */

    }, {
      key: "addEventListeners",
      value: function addEventListeners() {
        document.addEventListener('click', this.handleClick, false);
      }
    }]);

    return Notification;
  }();

  /**
   * Search toggle class.
   */
  var SearchToggle =
  /*#__PURE__*/
  function () {
    /**
     * Constructor.
     *
     * @param {DomNode} btn
     * @param {DomNode} container
     * @param {Object} options
     */
    function SearchToggle(btn, container, options) {
      _classCallCheck(this, SearchToggle);

      this.btn = btn;
      this.container = container;
      this.config = _objectSpread2(_objectSpread2({}, {}), options);
      this.handleClick = this.handleClick.bind(this);
      this.handleBlur = this.handleBlur.bind(this);
      this.handleKeyDown = this.handleKeyDown.bind(this);
      this.addEventListeners();
    }
    /**
     * Handle click.
     */


    _createClass(SearchToggle, [{
      key: "handleClick",
      value: function handleClick() {
        var expanded = 'true' === this.btn.getAttribute('aria-expanded') || false;
        this.btn.setAttribute('aria-expanded', !expanded);
      }
      /**
       *
       * @param {Event} event
       */

    }, {
      key: "handleBlur",
      value: function handleBlur(event) {
        if (!event.relatedTarget) return;
        var expanded = 'true' === this.btn.getAttribute('aria-expanded') || false;

        if (expanded && !event.relatedTarget.closest('.search-form') && event.relatedTarget !== this.btn) {
          this.btn.setAttribute('aria-expanded', false);
        }
      }
      /**
       * @param {Event} event
       */

    }, {
      key: "handleKeyDown",
      value: function handleKeyDown(event) {
        var expanded = 'true' === this.btn.getAttribute('aria-expanded') || false;
        if (!expanded) return false;

        if (27 === event.keyCode) {
          this.btn.setAttribute('aria-expanded', false);
          this.btn.focus();
        }
      }
      /**
       * Add event listeners.
       */

    }, {
      key: "addEventListeners",
      value: function addEventListeners() {
        var _this = this;

        this.btn.addEventListener('click', this.handleClick, false);
        Array.prototype.forEach.call(this.container.querySelectorAll('input, button'), function (el) {
          el.addEventListener('blur', _this.handleBlur, false);
        });
        document.addEventListener('keydown', this.handleKeyDown, false);
      }
    }]);

    return SearchToggle;
  }();

  /**
   * Toggle Button class.
   */
  var ToggleButton =
  /*#__PURE__*/
  function () {
    /**
     * Constructor.
     *
     * @param {Object} options
     */
    function ToggleButton(options) {
      _classCallCheck(this, ToggleButton);

      this.config = _objectSpread2(_objectSpread2({}, {
        selector: '.button--toggle'
      }), options);
      this.handleClick = this.handleClick.bind(this);
      this.addEventListeners();
    }
    /**
     * Handle click.
     *
     * @param {Event} event
     */


    _createClass(ToggleButton, [{
      key: "handleClick",
      value: function handleClick(event) {
        if (!event.target.closest(this.config.selector)) return;
        var btn = event.target.closest(this.config.selector);
        var pressed = 'true' === btn.getAttribute('aria-pressed') || false;
        btn.setAttribute('aria-pressed', !pressed);
      }
      /**
       * Add event listeners.
       */

    }, {
      key: "addEventListeners",
      value: function addEventListeners() {
        document.addEventListener('click', this.handleClick);
      }
    }]);

    return ToggleButton;
  }();

  /**
   * Radio Grou class.
   */
  var RadioGroup =
  /*#__PURE__*/
  function () {
    /**
     * Constructor.
     *
     * @param {DomNode} container
     * @param {Object} options
     */
    function RadioGroup(container, options) {
      _classCallCheck(this, RadioGroup);

      this.radioGroup = container;
      this.keyCode = Object.freeze({
        'LEFT': 37,
        'UP': 38,
        'RIGHT': 39,
        'DOWN': 40
      });
      this.config = _objectSpread2(_objectSpread2({}, {
        groupSelector: '.radio-group'
      }), options);
      this.handleClick = this.handleClick.bind(this);
      this.handleKeyDown = this.handleKeyDown.bind(this);
      this.setCheckedToPreviousItem = this.setCheckedToPreviousItem.bind(this);
      this.setCheckedToNextItem = this.setCheckedToNextItem.bind(this);
      this.addEventListeners();
    }
    /**
     * Handle click.
     *
     * @param {Event} event
     */


    _createClass(RadioGroup, [{
      key: "handleClick",
      value: function handleClick(event) {
        if (!event.target.closest(this.config.groupSelector)) return;
        if ('BUTTON' !== event.target.nodeName) return;
        var checkedItem = this.radioGroup.querySelector('[aria-checked="true"]');

        if ('false' === event.target.getAttribute('aria-checked') && checkedItem) {
          checkedItem.setAttribute('aria-checked', false);
          event.target.setAttribute('aria-checked', true);
        }
      }
      /**
       * Handle keydown.
       *
       * @param {Event} event
       */

    }, {
      key: "handleKeyDown",
      value: function handleKeyDown(event) {
        if (!document.activeElement.closest(this.config.groupSelector)) return;

        switch (event.keyCode) {
          case this.keyCode.UP:
            this.setCheckedToPreviousItem(document.activeElement);
            break;

          case this.keyCode.DOWN:
            this.setCheckedToNextItem(document.activeElement);
            break;

          case this.keyCode.LEFT:
            this.setCheckedToPreviousItem(document.activeElement);
            break;

          case this.keyCode.RIGHT:
            this.setCheckedToNextItem(document.activeElement);
            break;
        }
      }
      /**
       * Move checked state to previous item.
       */

    }, {
      key: "setCheckedToPreviousItem",
      value: function setCheckedToPreviousItem() {
        var previousItem = document.activeElement.previousElementSibling;

        if (!previousItem) {
          var buttons = this.radioGroup.querySelectorAll('button');
          previousItem = buttons[buttons.length - 1];
        }

        var checkedItem = this.radioGroup.querySelector('[aria-checked="true"]');
        checkedItem.setAttribute('aria-checked', false);
        previousItem.setAttribute('aria-checked', true);
        previousItem.focus();
      }
      /**
       * Move checked state to next item.
       */

    }, {
      key: "setCheckedToNextItem",
      value: function setCheckedToNextItem() {
        var nextItem = document.activeElement.nextElementSibling;

        if (!nextItem) {
          var button = this.radioGroup.querySelector('button');
          nextItem = button;
        }

        var checkedItem = this.radioGroup.querySelector('[aria-checked="true"]');
        checkedItem.setAttribute('aria-checked', false);
        nextItem.setAttribute('aria-checked', true);
        nextItem.focus();
      }
      /**
       * Add event listeners.
       */

    }, {
      key: "addEventListeners",
      value: function addEventListeners() {
        document.addEventListener('click', this.handleClick);
        document.addEventListener('keydown', this.handleKeyDown);
      }
    }]);

    return RadioGroup;
  }();

  /**
   * Tabs class.
   *
   * @see https://github.com/zachleat/seven-minute-tabs/
   */
  var Tabs =
  /*#__PURE__*/
  function () {
    /**
     * Constructor.
     *
     * @param {DomNode} container
     * @param {Object} options
     */
    function Tabs(container, options) {
      _classCallCheck(this, Tabs);

      this.container = container;
      this.tablist = this.container.querySelector('[role="tablist"]');
      this.buttons = this.container.querySelectorAll('[role="tab"]');
      this.panels = this.container.querySelectorAll('[role="tabpanel"]');
      this.delay = this.determineDelay();
      this.config = _objectSpread2(_objectSpread2({}, {
        groupSelector: '.tabs'
      }), options);
      this.handleClick = this.handleClick.bind(this);
      this.handleKeyDown = this.handleKeyDown.bind(this);
      this.handleKeyUp = this.handleKeyUp.bind(this);
      this.initButtons = this.initButtons.bind(this);
      this.initPanels = this.initPanels.bind(this);
      this.initButtons();
      this.initPanels();
    }
    /**
     * Enumerate key codes that we need to detect.
     */


    _createClass(Tabs, [{
      key: "initButtons",

      /**
       * Initialize buttons.
       */
      value: function initButtons() {
        var count = 0;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = this.buttons[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var button = _step.value;
            var isSelected = 'true' === button.getAttribute('aria-selected');
            button.setAttribute('tabindex', isSelected ? '0' : '-1');
            button.addEventListener('click', this.handleClick);
            button.addEventListener('keydown', this.handleKeyDown);
            button.addEventListener('keyup', this.handleKeyUp);
            button.index = count++;
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
              _iterator["return"]();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
      /**
       * Initialize panels.
       */

    }, {
      key: "initPanels",
      value: function initPanels() {
        var selectedPanelId = this.container.querySelector('[role="tab"][aria-selected="true"]').getAttribute('aria-controls');
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = this.panels[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var panel = _step2.value;

            if (panel.getAttribute('id') !== selectedPanelId) {
              panel.setAttribute('hidden', '');
            }

            panel.setAttribute('tabindex', '0');
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
              _iterator2["return"]();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }
      /**
       * Handle click.
       *
       * @param {Event} event
       */

    }, {
      key: "handleClick",
      value: function handleClick(event) {
        var button = event.target;

        if ('A' === button.tagName) {
          event.preventDefault();
        }

        this.activateTab(button, false);
      }
      /**
       * Deactivate all tabs.
       */

    }, {
      key: "deactivateTabs",
      value: function deactivateTabs() {
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = this.buttons[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var button = _step3.value;
            button.setAttribute('tabindex', '-1');
            button.setAttribute('aria-selected', 'false');
            button.removeEventListener('focus', this.focusEventHandler.bind(this));
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3["return"] != null) {
              _iterator3["return"]();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }

        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = this.panels[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var panel = _step4.value;
            panel.setAttribute('hidden', 'hidden');
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4["return"] != null) {
              _iterator4["return"]();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }
      }
      /**
       * Handle focus events.
       *
       * @param {Event} event
       */

    }, {
      key: "focusEventHandler",
      value: function focusEventHandler(event) {
        var target = event.target;
        setTimeout(this.checkTabFocus.bind(this), this.delay, target);
      }
      /**
       * Activate a tab.
       *
       * @param {DomNode} tab
       * @param {Boolean} setFocus
       */

    }, {
      key: "activateTab",
      value: function activateTab(tab, setFocus) {
        if ('tab' !== tab.getAttribute('role')) {
          tab = tab.closest('[role="tab"]');
        }

        setFocus = setFocus || true;
        this.deactivateTabs();
        tab.removeAttribute('tabindex');
        tab.setAttribute('aria-selected', 'true');
        var controls = tab.getAttribute('aria-controls');
        document.getElementById(controls).removeAttribute('hidden');

        if (setFocus) {
          tab.focus();
        }
      }
      /**
       * Handle keydown.
       *
       * @param {Event} event
       */

    }, {
      key: "handleKeyDown",
      value: function handleKeyDown(event) {
        var key = event.keyCode;

        switch (key) {
          case this.keys.end:
            event.preventDefault();
            this.activateTab(this.buttons[this.buttons.length - 1]);
            break;

          case this.keys.home:
            event.preventDefault();
            this.activateTab(this.buttons[0]);
            break;

          case this.keys.up:
          case this.keys.down:
            this.determineOrientation(event);
            break;
        }
      }
      /**
       * Handle keyup.
       *
       * @param {Event} event
       */

    }, {
      key: "handleKeyUp",
      value: function handleKeyUp(event) {
        var key = event.keyCode;

        switch (key) {
          case this.keys.left:
          case this.keys.right:
            this.determineOrientation(event);
            break;
        }
      }
      /**
       * Check which orientation we're in.
       *
       * @param {Event} event
       */

    }, {
      key: "determineOrientation",
      value: function determineOrientation(event) {
        var key = event.keyCode;
        var vertical = 'vertical' == this.tablist.getAttribute('aria-orientation');
        var proceed = false;

        if (vertical) {
          if (key === this.keys.up || key === this.keys.down) {
            event.preventDefault();
            proceed = true;
          }
        } else {
          if (key === this.keys.left || key === this.keys.right) {
            proceed = true;
          }
        }

        if (proceed) {
          this.switchTabOnArrowPress(event);
        }
      }
      /**
       * Switch tab when arrow key is pressed.
       *
       * @param {Event} event
       */

    }, {
      key: "switchTabOnArrowPress",
      value: function switchTabOnArrowPress(event) {
        var pressed = event.keyCode;
        var _iteratorNormalCompletion5 = true;
        var _didIteratorError5 = false;
        var _iteratorError5 = undefined;

        try {
          for (var _iterator5 = this.buttons[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
            var button = _step5.value;
            button.addEventListener('focus', this.focusEventHandler.bind(this));
          }
        } catch (err) {
          _didIteratorError5 = true;
          _iteratorError5 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion5 && _iterator5["return"] != null) {
              _iterator5["return"]();
            }
          } finally {
            if (_didIteratorError5) {
              throw _iteratorError5;
            }
          }
        }

        if (this.direction[pressed]) {
          var target = event.target;

          if (target.index !== undefined) {
            if (this.buttons[target.index + this.direction[pressed]]) {
              this.buttons[target.index + this.direction[pressed]].focus();
            } else if (pressed === this.keys.left || pressed === this.keys.up) {
              this.focusLastTab();
            } else if (pressed === this.keys.right || pressed == this.keys.down) {
              this.focusFirstTab();
            }
          }
        }
      }
      /**
       * Focus the first tab.
       */

    }, {
      key: "focusFirstTab",
      value: function focusFirstTab() {
        this.buttons[0].focus();
      }
      /**
       * Focus the last tab.
       */

    }, {
      key: "focusLastTab",
      value: function focusLastTab() {
        this.buttons[this.buttons.length - 1].focus();
      }
      /**
       * Determine if there should be a delay.
       */

    }, {
      key: "determineDelay",
      value: function determineDelay() {
        var hasDelay = this.tablist.hasAttribute('data-delay');
        var delay = 0;

        if (hasDelay) {
          var delayValue = this.tablist.getAttribute('data-delay');

          if (delayValue) {
            delay = delayValue;
          } else {
            delay = 300;
          }
        }

        return delay;
      }
      /**
       *
       * @param {DomNode} target
       */

    }, {
      key: "checkTabFocus",
      value: function checkTabFocus(target) {
        var focused = document.activeElement;

        if (target === focused) {
          this.activateTab(target, false);
        }
      }
    }, {
      key: "keys",
      get: function get() {
        return {
          end: 35,
          home: 36,
          left: 37,
          up: 38,
          right: 39,
          down: 40
        };
      }
      /**
       * Determine direction based on key pressed.
       */

    }, {
      key: "direction",
      get: function get() {
        return {
          37: -1,
          38: -1,
          39: 1,
          40: 1
        };
      }
    }]);

    return Tabs;
  }();

  var index = {
    Accordion: Accordion,
    Card: Card,
    DeselectAll: DeselectAll,
    Dialog: Dialog,
    DisclosureButton: DisclosureButton,
    FilterList: FilterList,
    Icon: Icon,
    Menu: Menu,
    MenuButton: MenuButton,
    NestedCheckbox: NestedCheckbox,
    Notification: Notification,
    SearchToggle: SearchToggle,
    ToggleButton: ToggleButton,
    RadioGroup: RadioGroup,
    Tabs: Tabs
  };

  return index;

})));
